module.exports = __webpack_public_path__ + "img/chevron-down-white.0d49a378.svg";